<template>
	<WebViewLayout class="pt-200">
		<div class="container">
			<p>
				1. Figures represent the weighted average aggregate performance of all client accounts during the
				periods indicated, including any shares acquired as a result of the reinvestment of dividends, and net
				of a 0.15% advisory fee, if applicable. Commissions are not considered since clients of Fundrise
				Advisors are not charged trading commissions or any other transaction-based fees. Returns were
				calculated using the Modified Dietz method. This information is presented for informational purposes
				only. Past performance is not indicative of future results, and any investment carries with it the risk
				of loss.
			</p>
			<p>
				2. Specifically, the S&amp;P 500 index total return, which includes both dividends and capital gains /
				losses, for the period indicated. The index includes 500 leading companies and covers approximately 80%
				of available market capitalization of US publicly listed stocks. As an index, the S&amp;P 500 is
				inherently not investable, and is presented for informational purposes only.
			</p>
		</div>
	</WebViewLayout>
</template>

<script setup lang="ts">
import WebViewLayout from '@views/webview/web-view-layout.vue';
</script>
